import { apiClient } from "@/services/api";

const state = () => ({
    noticiasAprovadas: null,
    noticiasModeradas: null,
    flg_favorita: false,
    filtro_aprovadas: localStorage.getItem("@socialcam/filtro_texto_noticia") ? localStorage.getItem("@socialcam/filtro_texto_noticia") : null,
    filtro_moderadas: null
})

const getters = {
    getterNoticiasAprovadas: state => {
        return state.noticiasAprovadas
    },
    getterNoticiasModeradas: state => {
        return state.noticiasModeradas
    },
    getterFlgFavorita: state => {
        return state.flg_favorita
    },
    getterFiltroAprovadas: state => {
        return state.filtro_aprovadas
    },
    getterFiltroModeradas: state => {
        return state.filtro_moderadas
    }
}

const actions = {
    async getNoticiasAprovadas({ commit }, payload) {
        const { cod_portal, cod_producao, cod_editoria, filtro_texto, flg_favorita, page, size, cod_pasta } = payload;
        await apiClient.get(
            `noticias/listarNoticiasPorPortal/${cod_portal}/${cod_producao}?page=${page ? page : ''}&size=${size ? size : ''}&filtro_texto=${filtro_texto ? filtro_texto : ''}&flg_favorita=${flg_favorita ? flg_favorita : ''}&cod_pasta=${cod_pasta}&cod_editoria=${cod_editoria}`
        )
            .then((response) => {
                commit('setNoticiasAprovadas', response.data.noticias)
            }).catch(error => {
                console.error(error.message)
            })
    },
    async getNoticiasModeradas({ commit }, payload) {
        const { cod_portal, cod_producao, page, size, filtro_texto } = payload;

        await apiClient.get(`noticiasModeradas/listarNoticiasModeradasPorProducao/${cod_producao}/${cod_portal}/?page=${page ? page : ''}&size=${size ? size : ''}&filtro_texto=${filtro_texto ? filtro_texto : ''}`)
            .then((response) => {
                commit('setNoticiasModeradas', response.data.noticiasModeradas)
            }).catch(error => {
                console.error(error.message)
            })
    },
    setFlgFavorita({ commit }, value) {
        try {
            commit('setFlgFavorita', value)
        } catch (error) {
            console.error(error)
        }
    },
    setFiltroAprovadas({ commit }, value) {
        try {
            commit('setFiltroAprovadas', value)
        } catch (error) {
            console.error(error)
        }
    },
    setFiltroModeradas({ commit }, value) {
        try {
            commit('setFiltroModeradas', value)
        } catch (error) {
            console.error(error)
        }
    }
}

const mutations = {
    setNoticiasAprovadas(state, value) {
        state.noticiasAprovadas = value
    },
    setNoticiasModeradas(state, value) {
        state.noticiasModeradas = value
    },
    setFlgFavorita(state, value) {
        state.flg_favorita = value
    },
    setFiltroAprovadas(state, value) {
        state.filtro_aprovadas = value
    },
    setFiltroModeradas(state, value) {
        state.filtro_moderadas = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}